import { render } from "./Text.vue?vue&type=template&id=e12150aa"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/Questionnaire/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e12150aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e12150aa', __exports__)) {
    api.reload('e12150aa', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=e12150aa", () => {
    api.rerender('e12150aa', render)
  })

}


export default __exports__